import { invokeApi } from "src/bl_libs/invokeApi";

/** Logged-in member portal — trackers this member can access. */
export const getMemberTrackersApi = async () => {
  const requestObj = {
    path: `/api/member_tracker`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

/** Logged-in member portal — one tracker + own submissions. */
export const getMemberTrackerDetailApi = async (idOrSlug) => {
  const requestObj = {
    path: `/api/member_tracker/${encodeURIComponent(idOrSlug)}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

/**
 * Logged-in member portal — submit tracker answers.
 * Always sends x-sh-auth; backend tags source = gymrite_member.
 */
export const submitMemberTrackerApi = async (idOrSlug, data = {}) => {
  const requestObj = {
    path: `/api/member_tracker/${encodeURIComponent(idOrSlug)}/submissions`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: {
      formId: data.formId || "",
      answers: data.answers || {},
    },
  };
  return invokeApi(requestObj);
};
